/**
 * Every user account permission is namespaced with this prefix.
 */
export const ACCOUNT_FEATURE_PREFIX = 'Account.';

export enum UserAccountFeature {
    Admin = 'Account.Admin',
    ProjectManager = 'Account.ProjectManager',
    Finance = 'Account.Finance',
    Operator = 'Account.Operator',
    ViewContracts = 'Account.ViewContracts',
    SeePricing = 'Account.SeePricing',
    ViewItemsOnRent = 'Account.ViewItemsOnRent',
    PaymentHistory = 'Account.PaymentHistory',
    RequestCallOff = 'Account.RequestCallOff',
    RequestService = 'Account.RequestService',
    ViewInvoices = 'Account.ViewInvoices',
    ManageUsers = 'Account.ManageUsers',
    UseHapnGps = 'Account.UseHapnGps'
}

/**
 * Operator is mutually exclusive with the management trio (Admin / ProjectManager / Finance).
 * Single source of truth for both the modal exclusion logic and any caller that needs
 * to enumerate management permissions.
 */
export const managementPermissions: readonly UserAccountFeature[] = [UserAccountFeature.Admin, UserAccountFeature.ProjectManager, UserAccountFeature.Finance];
